import React from 'react'
import styles from "./UserProfileMobile.module.css"

function UserProfileMobile({ userData: initialUserData }) {

    console.log("anurag test", initialUserData)

    return (
        <div className={styles.mainContainer}>
            <div
                className={styles.greeting}
            >
                Hey, "{initialUserData?.firstName || "Rituals"}" Earning ho raha hain na?
            </div>
            <div className={styles.profileImageContainer}>
                <img
                    src={initialUserData?.photoUrl || "/placeholder.svg?height=200&width=200"}
                    alt="Profile"
                    className={styles.profileImage}
                />
            </div>
            <div className={styles.infoContainer}>
                <div className={styles.roleContainer}>
                    <p
                        className={styles.roleText}
                    >
                        {
                            initialUserData?.userTypes.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
                        } : {
                            initialUserData?.firstName + initialUserData?.lastName || "Affiliate Ritual"
                        }

                    </p>
                </div>
                <div className={styles.regIdContainer}>
                    <p className={styles.regIdText}>REG.ID : {initialUserData?.myARID || "AR1234"}</p>
                </div>
                <div className={styles.coinContainer}>
                    <p className={styles.coinText}>{initialUserData?.totalCoins || "1234"} COINS</p>
                </div>
            </div>
        </div>
    )
}

export default UserProfileMobile